export default {"src":"https://static.finncdn.no/_c/travel/pp-web/_next/static/media/tg.d92acf6d.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};